var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 900,
        width: 1900,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", { attrs: { height: "115", width: "1900", y: "781", x: "0" } }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "180", width: "1900", y: "0", x: "0" } }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "240", width: "1900", y: "205", x: "0" } }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "275", width: "1900", y: "469", x: "0" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }